import * as USER from '@/store/constants/user';
import * as DOCTOR from '@/store/constants/doctor';

import NotificationMixin from '@/mixins/notification';

import Notification from '@/views/Common/Notification';
import {mapActions, mapGetters} from 'vuex';

export default {
  inject: ['$validator'],
  name: "userEdit",
  data() {
    return {
      editUser: {},
      new_password: null
    }
  },
  components: {Notification},
  mixins: [NotificationMixin],
  computed: {
    ...mapGetters({user: USER.GET_USER}),
    doctor() {
      return (this.editUser.doctor) ? this.editUser.doctor : {};
    }
  },
  methods: {
    ...mapActions({
      updateUser: USER.ACTION_UPDATE,
      updateDoctor: DOCTOR.ACTION_UPDATE,
      getUser: USER.ACTION_GET_USER
    }),

    changePassword() {
      this.editUser.password = this.new_password;
    },

    backToDetail() {
      this.user.doctor = this.doctor;
      this.$router.replace({name: 'UserDetail', params: {user: this.user}});
    },

    /**
     * Update user data.
     */
    save() {
      this.resetNotification();

      this.$validator.validateAll().then((valid) => {
        if (!valid) return;

        const payload = {
          id: this.editUser.id,
          payload: this.editUser,
          selfUpdate: false
        };

        // Flag as self update
        if (this.user.id === this.editUser.id) payload.selfUpdate = true;

        // Update user data.
        this.updateUser(payload).then(() => {
          this.showSuccessNotification('User information is successfully updated.');
          // Update doctor information.
          if (this.doctor) this.updateDoctor({id: this.doctor.id, payload: this.doctor});
        }).catch((e) => this.showErrorNotification(e.response.data.message))
      }).catch((e) => console.error(e));
    }
  },
  created() {
    this.getUser(this.$route.params['id']).then(res => this.editUser = res.data);
  }
}



// WEBPACK FOOTER //
// ./src/views/User/js/edit.js